<main class="wrapper-content flex-column pl-0 pr-2 md:pr-0  pl-3">

  <div class="back-button mb-2 mt-4">
    <a (click)="goToPage()" class="app-text-gray font-normal">
      <i class="pi pi-arrow-left icon-back-button"></i>
      <span class="ml-3"> {{ 'components.app-ver-informacion-tramite.volver-a-consulta' | translate }} </span>
    </a>
  </div>
  <section class="flex justify-content-center mt-4 ml-4 mb-2">
    <div *ngIf="hojaDeVida" class="col-12">
      <div class="flex flex-wrap">
        <div class="col-12 inline-flex mb-1">
          <img class="checkmark" src="assets/img/icons-principal/ico-checkmark.png">
          <h1 class="font-weight-medium text-lg title-blue"> {{ hojaDeVida.nombre }}</h1>
        </div>
        <div class="col-12 brand-blue-light ml-2" style="font-size:13px;">
          <p> {{ hojaDeVida.dependencia }} </p>
        </div>
        <div class="col-12 border-left-2 app-border-gray py-0 my-4 ml-2">
          <h2 class="label-form-sidebar subtitle mt-0 pt-0">
            {{ 'components.app-ver-informacion-tramite.para-que-sirve-y-que-consiste' | translate }}
          </h2>
          <p class="details-text mb-0 pb-0"> {{ hojaDeVida.descripcion }} </p>
        </div>
        <div class="col-12 border-left-2 app-border-gray py-0 my-4 ml-2 align-self-baseline">
          <h2 class="label-form-sidebar subtitle mt-0 pt-0">
            {{ 'components.app-ver-informacion-tramite.url-tramite' | translate }}</h2>
          <p class="details-text mb-0 pb-0 ">
            {{
              hojaDeVida.urlTramite ? hojaDeVida.urlTramite :
                'components.app-ver-informacion-tramite.no-url-tramite' | translate
            }}</p>
        </div>

        <div class="col-12  flex flex-wrap">
          <div class="col-6 md:col-3 mt-5 md:mt-0  border-left-2 app-border-gray py-0 align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.canal-atencion-tramite' | translate }}
            </h2>
            <div class="flex flex-column">
              @for (item of canalesAtencion; track $index; let last = $last) {
                <div class="inline-flex" [ngClass]="last ? 'mb-0' : 'mb-2'">
                  <ng-container *ngTemplateOutlet="statusIcon; context: {selected: item.selected}"></ng-container>
                  <p class="my-0" [ngClass]="item.selected ? 'seletected' :'not-seletected' ">
                    {{ item.text }}
                  </p>
                </div>
              }
            </div>
          </div>
          <div class="col-6 md:col-3 mt-5 md:mt-0 border-left-2 app-border-gray py-0 align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.dirigido-tramite' | translate }}
            </h2>
            <div class="flex flex-column">
              @for (item of dirigidoTramite; track $index; let last = $last) {
                <div class="inline-flex" [ngClass]="last ? 'mb-0' : 'mb-2'">
                  <ng-container *ngTemplateOutlet="statusIcon; context: {selected: item.selected}"></ng-container>
                  <p class="my-0" [ngClass]="item.selected ? 'seletected' :'not-seletected' ">
                    {{ item.text }}
                  </p>
                </div>
              }
            </div>
          </div>
          <div class="col-6 md:col-3 mt-5 md:mt-0 border-left-2 app-border-gray py-0 align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.enfoque-diferencial' | translate }}
            </h2>
            <div class="flex flex-column">
              @for (item of enfoqueDiferencial; track $index; let last = $last) {
                <div class="inline-flex" [ngClass]="last?'mb-0':'mb-2'">
                  <ng-container *ngTemplateOutlet="statusIcon; context: {selected: item.selected}"></ng-container>
                  <p class="my-0" [ngClass]="item.selected ? 'seletected' :'not-seletected' ">
                    {{ item.text }}
                  </p>
                </div>
              }
            </div>
          </div>
          <div class="col-6 md:col-3 mt-5 md:mt-0 border-left-2 app-border-gray py-0 align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.características-especiales' | translate }}
            </h2>
            <div class="flex flex-column">
              @for (item of caracteristicasEspeciales; track $index; let last = $last) {
                <div class="inline-flex" [ngClass]="last ? 'mb-0' : 'mb-2'">
                  <ng-container *ngTemplateOutlet="statusIcon; context: {selected: item.selected}"></ng-container>
                  <p class="my-0" [ngClass]="item.selected ? 'seletected' :'not-seletected' ">
                    {{ item.text }}
                  </p>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="col-12 flex">

          <div class="col-6 border-left-2 app-border-gray py-0 my-4  align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.periodo' | translate }}
            </h2>
            <p class="details-text mb-0 pb-0 "> {{ hojaDeVida.periodo }}</p>
          </div>

          <div class="col-6  border-left-2 app-border-gray py-0 my-4  align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.horarios-atencion' | translate }}
            </h2>
            <p class="details-text mb-0 pb-0 ">
              {{ hojaDeVida.horariosAtencion }}
            </p>
          </div>
        </div>
        <div class="col-12 border-left-2 app-border-gray py-0 my-4 ml-2 align-self-baseline">
          <h2 class="label-form-sidebar subtitle mt-0 pt-0">
            {{ 'components.app-ver-informacion-tramite.requisitos-tramite' | translate }}
          </h2>
          <p class="details-text mb-0 pb-0 "> {{ hojaDeVida.requisitos }}</p>
        </div>
        <div class="col-12 border-left-2 app-border-gray py-0 my-4 ml-2 align-self-baseline">
          <h2 class="label-form-sidebar subtitle mt-0 pt-0">
            {{ 'components.app-ver-informacion-tramite.ruta-tramite' | translate }}
          </h2>
          <p class="details-text mb-0 pb-0 "> {{ hojaDeVida.ruta }}</p>
        </div>
        <div class="col-12 border-left-2 app-border-gray py-0 my-4 ml-2 align-self-baseline">
          <h2 class="label-form-sidebar subtitle mt-0 pt-0">
            {{ 'components.app-ver-informacion-tramite.relacion-tramite' | translate }}
          </h2>
          <p class="details-text mb-0 pb-0 "> {{ hojaDeVida.relacion }}</p>
        </div>

        <div class="col-12 flex">

          <div class="col border-left-2 app-border-gray py-0 my-4  align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.norma' | translate }}
            </h2>
            <p class="details-text mb-0 pb-0 ">
              {{ hojaDeVida.norma }}
            </p>
          </div>
          <div class="col border-left-2 app-border-gray py-0 my-4  align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.plazo' | translate }}
            </h2>
            <p class="details-text mb-0 pb-0 ">
              {{ hojaDeVida.plazo }}
            </p>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col border-left-2 app-border-gray py-0 my-4  align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.requiere-pago' | translate }}
            </h2>
            <div class="flex flex-column">
              <div class="inline-flex mb-2">
                <ng-container
                  *ngTemplateOutlet="statusIcon; context: {selected: hojaDeVida.requierePago}"></ng-container>
                <p class="my-0" [ngClass]="hojaDeVida.requierePago ? 'seletected' :'not-seletected' ">Si</p>
              </div>
              <div class="inline-flex mb-2">
                <ng-container
                  *ngTemplateOutlet="statusIcon; context: {selected: !hojaDeVida.requierePago}"></ng-container>
                <p class="my-0" [ngClass]="!hojaDeVida.requierePago ? 'seletected' :'not-seletected' ">No</p>
              </div>
            </div>
          </div>
          @if(hojaDeVida.requierePago){
            <div class="col border-left-2 app-border-gray py-0 my-4  align-self-baseline">
              <h2 class="label-form-sidebar subtitle mt-0 pt-0">
                {{ 'components.app-ver-informacion-tramite.valor' | translate }}
              </h2>
              <p class="details-text mb-0 pb-0 ">
                {{ hojaDeVida.valor }}
              </p>
            </div>
          }
        </div>

        @if(hojaDeVida.requierePago){
          <div class="col-12 flex flex-column">
            <h1 class="col-12 font-weight-medium text-lg title-blue pl-0 ml-0">
              {{ 'components.app-ver-informacion-tramite.cuenta-realiza-pago' | translate }}
            </h1>
            <div class="flex flex-wrap">
              <div class="col-6 md:col-4 border-left-2 app-border-gray py-0 my-4  align-self-baseline">
                <h2 class="label-form-sidebar subtitle mt-0 pt-0">
                  {{ 'components.app-ver-informacion-tramite.tipo-cuenta' | translate }}
                </h2>
                <p class="details-text mb-0 pb-0 "> {{ hojaDeVida.tipoCuenta }}</p>
              </div>

              <div class="col-6 md:col-4 border-left-2 app-border-gray py-0 my-4  align-self-baseline">
                <h2 class="label-form-sidebar subtitle mt-0 pt-0">
                  {{ 'components.app-ver-informacion-tramite.nombre-banco' | translate }}
                </h2>
                <p class="details-text mb-0 pb-0 "> {{ hojaDeVida.nombreBanco }}</p>
              </div>
              <div class="col-6 md:col-4 border-left-2 app-border-gray py-0 my-4  align-self-baseline">
                <h2 class="label-form-sidebar subtitle mt-0 pt-0">
                  {{ 'components.app-ver-informacion-tramite.numero' | translate }}
                </h2>
                <p class="details-text mb-0 pb-0 "> {{ hojaDeVida.numeroCuenta }}</p>
              </div>

            </div>
          </div>
        }


        <div class="col-12 flex flex-wrap">
          <div class="col-6 md:col-4 border-left-2 app-border-gray py-0 align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.direccion' | translate }}
            </h2>
            <p class="details-text mb-0 pb-0"> {{ hojaDeVida.direccion }} </p>
          </div>
          <div class="col-6 md:col-4 border-left-2 app-border-gray py-0 align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.telefono' | translate }}
            </h2>
            <p class="details-text mb-0 pb-0"> {{ hojaDeVida.telefono }} </p>
          </div>
          <div class="col-6 mt-5 md:mt-0 md:col-4 border-left-2 app-border-gray py-0 align-self-baseline">
            <h2 class="label-form-sidebar subtitle mt-0 pt-0">
              {{ 'components.app-ver-informacion-tramite.correo' | translate }}
            </h2>
            <p class="details-text mb-0 pb-0"> {{ hojaDeVida.correo }} </p>
          </div>
        </div>

        <div class="col-12 border-left-2 app-border-gray py-0 my-4 ml-2">
          <h2 class="label-form-sidebar subtitle mt-0 pt-0">
            {{ 'components.app-ver-informacion-tramite.observaciones' | translate }}
          </h2>
          <p class="details-text mb-0 pb-0">
            {{ hojaDeVida.observaciones ? hojaDeVida.observaciones : 'components.app-ver-informacion-tramite.no-observaciones' | translate }}
          </p>
        </div>


        <div class="col-12 flex justify-content-center gap-3">
          <button pButton type="submit" [label]="'components.app-ver-informacion-tramite.iniciar-tramite' | translate"
                  class="bg-button-outline-blue-light border-outline-blue-light border-round-3xl hover:bg-blue-100
                   text-blue-general col-12 w-12rem"
                  (click)="onIniciarTramite()"></button>
        </div>
      </div>
    </div>
  </section>
</main>


<ng-template #statusIcon let-selected="selected">
  <i *ngIf="selected; else notSelected" class="pi pi-check-circle mr-2 seletected"></i>
  <ng-template #notSelected>
    <i class="pi pi-times-circle mr-2 not-seletected"></i>
  </ng-template>
</ng-template>
